<template>
    <Title class="highlight">
        <slot />
    </Title>
</template>

<script setup lang="ts">
    import Title from '~/components/Title.vue';
</script>

<style lang="scss" scoped>
    .highlight {
        :deep(strong) {
            display: inline-block;
            width: fit-content;
            position: relative;
            padding: 2px 4px 4px 12px;
            font-size: var(--joy-font-size-primary-800);
            color: var(--joy-color-neutral-0);

            &:before {
                z-index: -1;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                content: '';
                border-radius: 9999px;
                background-color: var(--joy-color-primary-50);
                transform: rotate(-1deg);
            }
        }
    }
</style>
